import 'babel-polyfill'

import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import theme from './theme.js'

import Vuetify from 'vuetify/es5/components/Vuetify'
import VApp from 'vuetify/es5/components/VApp'
import VProgressLinear from 'vuetify/es5/components/VProgressLinear'
import VGrid from 'vuetify/es5/components/VGrid'
import VForm from 'vuetify/es5/components/VForm'
import VDivider from 'vuetify/es5/components/VDivider'
import VCard from 'vuetify/es5/components/VCard'
import VList from 'vuetify/es5/components/VList'
import VToolbar from 'vuetify/es5/components/VToolbar'
import VTooltip from 'vuetify/es5/components/VTooltip'
import VBtn from 'vuetify/es5/components/VBtn'
import VIcon from 'vuetify/es5/components/VIcon'
import VTextField from 'vuetify/es5/components/VTextField'
import VCheckbox from 'vuetify/es5/components/VCheckbox'
import VAlert from 'vuetify/es5/components/VAlert'
import transitions from 'vuetify/es5/components/transitions'
import directives from 'vuetify/es5/directives'

require('vuetify/src/stylus/app.styl');

import App from './components/App.vue'
import Login from './components/Login.vue'
import Register from './components/Register.vue'
import EmailValidate from './components/EmailValidate.vue'
import ForgotPassword from './components/ForgotPassword.vue'

import axios from 'axios'

window.wsl = (serviceName) => {
  return new Promise((resolve, reject) => {
    axios.get("/wsl?serviceURI=" + appConfig.tag + "/" + serviceName)
      .then((response) => {
        resolve(response.data.url);
      })
      .catch((err) => {
        reject(err);
      })
  });
};


window.Vue = Vue;

Vue.use(VueRouter);

Vue.use(Vuetify, {
  components: {
    VApp,
    VGrid,
    VForm,
    VDivider,
    VCard,
    VList,
    VToolbar,
    VTooltip,
    VBtn,
    VIcon,
    VTextField,
    VCheckbox,
    VAlert,
    VProgressLinear
  },
  directives,
  transitions,
  iconfont: 'mdi',
  theme: theme
});

let params = new URLSearchParams(window.location.search);
let wsRedirectAfterLogin = params.get("r") || null;
let urlRedirectAfterLogin = params.get("rUrl") || null;
store.state.loginType = params.get("type") || null;

const router = new VueRouter({
  mode: 'history',
  base: (new URL(appConfig.webAppURL)).pathname,
  routes: [{
    path: "/login",
    name: "login",
    component: Login
  }, {
    path: "/register",
    name: "register",
    component: Register
  }, {
    path: "/emailValidate",
    name: "emailValidate",
    component: EmailValidate,
    props: (route) => ({ eventUid: route.query.eventUid })
  }, {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: ForgotPassword,
    props: (route) => ({ eventUid: route.query.eventUid })
  }]
});

router.beforeEach((to, from, next) => {
  store.dispatch("meAccount").then(() => {
    if (to.name) {
      next();
    } else {
      var account = store.state.account;
      if (account) {
        if (to.path === "/logout") {
          store.dispatch("logout").then(() => {
            if (urlRedirectAfterLogin) {
              window.location = urlRedirectAfterLogin
              return
            }
            next("/login");
          });
        } else {
          if (account.emailValid) {
            if (urlRedirectAfterLogin) {
              if (store.state.loginType === 'responseCode') {
                window.location = urlRedirectAfterLogin + "?responseCode=" + store.state.responseCode
              } else {
                window.location = urlRedirectAfterLogin
              }
              return
            }
            let ws = wsRedirectAfterLogin || "org.ntex.iris.cabinet/webapp";
            wsl(ws)
              .then((url) => {
                window.location = url + "/";
              });
          } else {
            next("/emailValidate");
          }
        }
      } else {
        next("/login");
      }
    }
  })
});

let axiosRequestId = 0;

async function initAPIClient(serviceName) {
  let axiosInstance = axios.create();
  axiosInstance.defaults.timeout = 30000;
  axiosInstance.interceptors.request.use((config) => {
    config.__requestId = axiosRequestId++;
    store.state.activeRequests.push(config.__requestId);
    return config;
  });
  axiosInstance.interceptors.response.use(
    (response) => {
      store.state.activeRequests.splice(store.state.activeRequests.indexOf(response.config.__requestId));
      return response;
    },
    (error) => {
      store.state.activeRequests.splice(store.state.activeRequests.indexOf(error.response.config.__requestId));
      let errorText = "";
      if (error.response) {
        errorText = "Ошибка " + error.response.status;
        if (error.response.data.err) {
          errorText += ": " + error.response.data.err;
        }
      } else {
        errorText = error.message;
      }
      store.state.errorList.push(errorText);
      return Promise.reject(error);
    });

  axiosInstance.defaults.baseURL = await wsl(serviceName);
  return axiosInstance;
}

async function init() {
  window.coreAPIClient = await initAPIClient("org.ntex.iris.core/webapi");

  new Vue({
    el: "#app",
    store,
    router,
    render: h => h(App)
  });
}

init();






// WEBPACK FOOTER //
// ./webapp/main.js